/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientSecurityRequestResponse } from '../models/ClientSecurityRequestResponse';
import type { CreateSecurityRequestDto } from '../models/CreateSecurityRequestDto';
import type { LocationSecurityResponse } from '../models/LocationSecurityResponse';
import type { SecurityConfigurationDto } from '../models/SecurityConfigurationDto';
import type { SecurityEstimateResponse } from '../models/SecurityEstimateResponse';
import type { SecurityOverviewResponse } from '../models/SecurityOverviewResponse';
import type { UpdateLocationSecuritySystemsDto } from '../models/UpdateLocationSecuritySystemsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SecurityService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Security overview of my locations
     * Returns every active location of the client with its security status, the equipment declared and the requests sent to Wisecure.
     * @returns SecurityOverviewResponse
     * @throws ApiError
     */
    public securityControllerGetOverview(): CancelablePromise<SecurityOverviewResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/me/security',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Client profile not found.`,
            },
        });
    }
    /**
     * Security of one location
     * Returns the security status, the declared equipment and the requests of a location owned by the client.
     * @returns LocationSecurityResponse
     * @throws ApiError
     */
    public securityControllerGetLocationSecurity({
        id,
    }: {
        /**
         * Location ID
         */
        id: string,
    }): CancelablePromise<LocationSecurityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/me/locations/{id}/security',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Not the owner of the location.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Declare the equipment installed at a location
     * Replaces the list of security equipment the client already has at this location (one entry per category). Send an empty list to remove everything.
     * @returns LocationSecurityResponse
     * @throws ApiError
     */
    public securityControllerUpdateSystems({
        id,
        requestBody,
    }: {
        /**
         * Location ID
         */
        id: string,
        requestBody: UpdateLocationSecuritySystemsDto,
    }): CancelablePromise<LocationSecurityResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/users/me/locations/{id}/security/systems',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or unknown brand.`,
                401: `Unauthorized.`,
                403: `Not the owner of the location.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Estimate a security system
     * Computes the installed price of a configuration (equipment list, price per plan, study cases) from the catalogue managed in the dashboard. Nothing is saved.
     * @returns SecurityEstimateResponse
     * @throws ApiError
     */
    public securityControllerEstimate({
        requestBody,
    }: {
        requestBody: SecurityConfigurationDto,
    }): CancelablePromise<SecurityEstimateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/security/estimates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Send a security request to Wisecure
     * Saves a request about a location (new system from the configurator, study, complement or repair) and emails the Wisecure team. The estimate is recomputed by the server.
     * @returns ClientSecurityRequestResponse
     * @throws ApiError
     */
    public securityControllerCreateRequest({
        requestBody,
    }: {
        requestBody: CreateSecurityRequestDto,
    }): CancelablePromise<ClientSecurityRequestResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/me/security/requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Not the owner of the location.`,
                404: `Location not found.`,
            },
        });
    }
}
